export default (theme) => {
    return {
        root: {
            width: 320,
            marginTop: -3,
            overflowWrap: 'anywhere',
        },
        isFullWidth: {
            width: '100%',
        },
        info: {
            ...theme.typography.caption,
            color: theme.colors.grey[500],
            paddingBottom: 5,
        },
        error: {
            ...theme.typography.caption,
            color: theme.colors.semantic.negative500,
            paddingBottom: 5,
        },
    };
};
